'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowLeftThick = function TiArrowLeftThick(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 18.3h-12.1l2.7-2.6c1.3-1.3 1.3-3.4 0-4.7-1.3-1.3-3.4-1.3-4.7 0l-10.7 10.7 10.7 10.7c0.6 0.6 1.5 0.9 2.3 0.9s1.7-0.3 2.4-0.9c1.3-1.3 1.3-3.5 0-4.8l-2.7-2.6h12.1c1.8 0 3.3-1.5 3.3-3.3 0-1.9-1.5-3.4-3.3-3.4z' })
        )
    );
};

exports.default = TiArrowLeftThick;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-left-thick.js
// module id = 1782
// module chunks = 0